// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topic-pairs-item {
  position: relative;
  margin-top: 1.8rem;
  margin-bottom: 1.8rem;
  padding-top: 1.8rem;
  padding-right: 3.6rem;
  padding-bottom: 1.8rem;
  padding-left: 3.6rem;
  background-color: #fff;
  border-radius: 2px;
  min-width: 100rem;
  box-shadow: 
    0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 
    0 1px 5px 0 rgba(0, 0, 0, 0.2);
}

.topic-pairs-item.item-added {
  box-shadow: 
    0 2px 2px 0 #26a69a,
    0 3px 1px -2px #26a69a, 
    0 1px 5px 0 #26a69a;
}

.topic-pairs-item.item-edited {
  box-shadow: 
    0 2px 2px 0 rgb(204, 204, 11),
    0 3px 1px -2px rgb(204, 204, 11), 
    0 1px 5px 0 rgb(204, 204, 11);
}

.topic-pairs-item.item-removed {
  box-shadow: 
    0 2px 2px 0 rgba(255, 0, 0),
    0 3px 1px -2px rgba(255, 0, 0), 
    0 1px 5px 0 rgba(255, 0, 0);
}

.topic-pairs-item .topic-pairs-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.topic-pairs-item-header__content {
  display: flex;
  align-items: center;
}

.topic-pairs-item .topic-pairs-item-header__content-grow {
  flex: 1;
  display: inline-block;
  text-align: left;
}

.topic-pairs-item-header__topic-pair-id {
  display: inline-flex;
}

.topic-pairs-item-header__trigger_name {
  position: absolute;
  margin-left: 0.9rem;
  display: inline-flex;
  width: 27rem;
}

.topic-pairs-item-header__trigger_name input {
  /* height: 7.3rem !important; */
}

.topic-pairs-item-header__category {
  position: absolute;
  margin-left: 28.8rem;
  display: inline-flex;
  width: 27rem;
}

.topic-pairs-item-header__category input {
  /* height: 4rem !important; */
}

.topic-pairs-item .topic-pairs-item-header__identifier {
  font-size: 3.6rem;
}

.topic-pairs-item .topic-pairs-item-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 2rem;
}

.topic-pairs-item {
  display: flex;
  flex-direction: row;
}

.topic-pairs-item_main-content-wrapper {
  flex: 1;
}

.topic-pair-items__input {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.topic-pair-items__input [type="checkbox"]+span:not(.lever):before, [type="checkbox"]:not(.filled-in)+span:not(.lever):after {
  left: 9px;
}
.topic-pair-items__input [type="checkbox"]:checked+span:not(.lever):before {
  left: 4px;
}

.topic-pairs-item__pending {
  display: flex;
  margin-left: 1rem;
}

.topic-pairs-item .topic-pairs-item__button {
  margin-left: 0.4rem;
  margin-right: 0.4rem;
}

.topic-pairs-item .topic-pairs-item__button-delete {
  background-color: #d22e37;
}

.topic-pairs-item .topic-pairs-item__button-active {
  background-color: #26a69a;
}

.topic-pairs-item .topic-pairs-item__button-create {
  background-color: #26a69a;
  width: 6rem;
  margin-bottom: 2rem;
}

.topic-pairs-item .topic-pairs-item__button-inactive {
  background-color: #d6ac17;
}

.topic-pairs-item .topic-pairs-item__button-move {
  background-color: #1976d2;
}

.topic-pairs-item .topic-pairs-item__button-save {
  background-color: #d6ac17;
}

.topic-pairs-item .topic-pairs-item__button-discard {
  background-color: #d22e37;
}

.topic-pairs-item .topic-pairs-item__question-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.topic-pairs-item .topic-pairs-item__question-editor {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-right: 5px;
}

.topic-pairs-item .topic-pairs-item__question-editor input {
  display: none;
}

.topic-pairs-item .topic-pairs-item__question-buttons {
  display: flex;
  flex-direction: row;
}

.topic-pairs-item__button-variant-answer {
  margin-right: 10.8rem;
  float: left;
}

.topic-pairs-item__button-variant-answer_checked {
  color: rgb(255, 255, 0);
}

.topic-pairs-item__question {
  display: flex;
  flex-direction: column;
}

.topic-pairs-item__variant-buttons {
  display: flex;
}

.topic-pairs-item__variant-buttons button {
  margin-right: 5px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.nlp-button-line {
  width: 100%;
  display: block;
}

.nlp-button-img-change-pos {
  display: inline-block;
  width: 1.8rem;
  visibility: hidden;
  opacity: 0.5;
  margin-right: 0.5rem;
}

.nlp-button-img-change-pos.change-pos-up {
  transform: rotate(180deg);
}

.nlp-buttons-container {
  margin-left: auto;
  margin-right: auto;
}

.nlp-button {
  background-color: ghostwhite;
  display: inline-block;
  width: 60%;
  padding: 0.2rem;
  border: solid 1px black;
  border-radius: 10px;
  cursor: pointer;
}

.nlp-button-img {
  width: 2.7rem;
  float: left;
}

.nlp-buttons-management {
  display: inline-flex;
  visibility: hidden;
  color: blue;
  cursor: pointer;
  gap: 10px;
  margin-left: 1.8rem;
}

.nlp-button-line:hover .nlp-buttons-management {
  visibility: visible;
}

.nlp-button-line:hover .nlp-button-img-change-pos {
  visibility: visible;
}

.add-nlp-button {
  width: 3.6rem;
  margin-right: 3.6rem;
  cursor: pointer;
}

.edit-nlp-button-dialog-container span {
  display: block;
  margin-bottom: 1.8rem;
}

.add-button-dialog .modal-title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-nlp-button-type {
  display: block;
}

.nlp-button__name {
  word-break: break-word;
}

.topic-pair-content-type__input {
  font-size: 1.8rem;
  display: inline-block;
  width: 22rem;
  height: 4rem;
  margin-right: 2rem;
  vertical-align: middle;
}

.input-wrapper {
    display: flex;
    align-items: center;
}

.warning-icon {
    color: red;
    font-size: 20px;
    margin-left: 8px;
    cursor: pointer;
}

.topic-pairs-item-header input[type="text"] {
    padding-bottom: 5px;
    height: auto;
    margin-top: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/nlp/topic-editor/topic-pairs-item/TopicPairsItem.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB;;;kCAGgC;AAClC;;AAEA;EACE;;;uBAGqB;AACvB;;AAEA;EACE;;;iCAG+B;AACjC;;AAEA;EACE;;;+BAG6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,UAAU;EACV,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB","sourcesContent":[".topic-pairs-item {\r\n  position: relative;\r\n  margin-top: 1.8rem;\r\n  margin-bottom: 1.8rem;\r\n  padding-top: 1.8rem;\r\n  padding-right: 3.6rem;\r\n  padding-bottom: 1.8rem;\r\n  padding-left: 3.6rem;\r\n  background-color: #fff;\r\n  border-radius: 2px;\r\n  min-width: 100rem;\r\n  box-shadow: \r\n    0 2px 2px 0 rgba(0, 0, 0, 0.14),\r\n    0 3px 1px -2px rgba(0, 0, 0, 0.12), \r\n    0 1px 5px 0 rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.topic-pairs-item.item-added {\r\n  box-shadow: \r\n    0 2px 2px 0 #26a69a,\r\n    0 3px 1px -2px #26a69a, \r\n    0 1px 5px 0 #26a69a;\r\n}\r\n\r\n.topic-pairs-item.item-edited {\r\n  box-shadow: \r\n    0 2px 2px 0 rgb(204, 204, 11),\r\n    0 3px 1px -2px rgb(204, 204, 11), \r\n    0 1px 5px 0 rgb(204, 204, 11);\r\n}\r\n\r\n.topic-pairs-item.item-removed {\r\n  box-shadow: \r\n    0 2px 2px 0 rgba(255, 0, 0),\r\n    0 3px 1px -2px rgba(255, 0, 0), \r\n    0 1px 5px 0 rgba(255, 0, 0);\r\n}\r\n\r\n.topic-pairs-item .topic-pairs-item-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.topic-pairs-item-header__content {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.topic-pairs-item .topic-pairs-item-header__content-grow {\r\n  flex: 1;\r\n  display: inline-block;\r\n  text-align: left;\r\n}\r\n\r\n.topic-pairs-item-header__topic-pair-id {\r\n  display: inline-flex;\r\n}\r\n\r\n.topic-pairs-item-header__trigger_name {\r\n  position: absolute;\r\n  margin-left: 0.9rem;\r\n  display: inline-flex;\r\n  width: 27rem;\r\n}\r\n\r\n.topic-pairs-item-header__trigger_name input {\r\n  /* height: 7.3rem !important; */\r\n}\r\n\r\n.topic-pairs-item-header__category {\r\n  position: absolute;\r\n  margin-left: 28.8rem;\r\n  display: inline-flex;\r\n  width: 27rem;\r\n}\r\n\r\n.topic-pairs-item-header__category input {\r\n  /* height: 4rem !important; */\r\n}\r\n\r\n.topic-pairs-item .topic-pairs-item-header__identifier {\r\n  font-size: 3.6rem;\r\n}\r\n\r\n.topic-pairs-item .topic-pairs-item-content {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.topic-pairs-item {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n.topic-pairs-item_main-content-wrapper {\r\n  flex: 1;\r\n}\r\n\r\n.topic-pair-items__input {\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.topic-pair-items__input [type=\"checkbox\"]+span:not(.lever):before, [type=\"checkbox\"]:not(.filled-in)+span:not(.lever):after {\r\n  left: 9px;\r\n}\r\n.topic-pair-items__input [type=\"checkbox\"]:checked+span:not(.lever):before {\r\n  left: 4px;\r\n}\r\n\r\n.topic-pairs-item__pending {\r\n  display: flex;\r\n  margin-left: 1rem;\r\n}\r\n\r\n.topic-pairs-item .topic-pairs-item__button {\r\n  margin-left: 0.4rem;\r\n  margin-right: 0.4rem;\r\n}\r\n\r\n.topic-pairs-item .topic-pairs-item__button-delete {\r\n  background-color: #d22e37;\r\n}\r\n\r\n.topic-pairs-item .topic-pairs-item__button-active {\r\n  background-color: #26a69a;\r\n}\r\n\r\n.topic-pairs-item .topic-pairs-item__button-create {\r\n  background-color: #26a69a;\r\n  width: 6rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.topic-pairs-item .topic-pairs-item__button-inactive {\r\n  background-color: #d6ac17;\r\n}\r\n\r\n.topic-pairs-item .topic-pairs-item__button-move {\r\n  background-color: #1976d2;\r\n}\r\n\r\n.topic-pairs-item .topic-pairs-item__button-save {\r\n  background-color: #d6ac17;\r\n}\r\n\r\n.topic-pairs-item .topic-pairs-item__button-discard {\r\n  background-color: #d22e37;\r\n}\r\n\r\n.topic-pairs-item .topic-pairs-item__question-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.topic-pairs-item .topic-pairs-item__question-editor {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  width: 100%;\r\n  margin-right: 5px;\r\n}\r\n\r\n.topic-pairs-item .topic-pairs-item__question-editor input {\r\n  display: none;\r\n}\r\n\r\n.topic-pairs-item .topic-pairs-item__question-buttons {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n.topic-pairs-item__button-variant-answer {\r\n  margin-right: 10.8rem;\r\n  float: left;\r\n}\r\n\r\n.topic-pairs-item__button-variant-answer_checked {\r\n  color: rgb(255, 255, 0);\r\n}\r\n\r\n.topic-pairs-item__question {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.topic-pairs-item__variant-buttons {\r\n  display: flex;\r\n}\r\n\r\n.topic-pairs-item__variant-buttons button {\r\n  margin-right: 5px;\r\n  border-top-left-radius: 10px;\r\n  border-top-right-radius: 10px;\r\n}\r\n\r\n.nlp-button-line {\r\n  width: 100%;\r\n  display: block;\r\n}\r\n\r\n.nlp-button-img-change-pos {\r\n  display: inline-block;\r\n  width: 1.8rem;\r\n  visibility: hidden;\r\n  opacity: 0.5;\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.nlp-button-img-change-pos.change-pos-up {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.nlp-buttons-container {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.nlp-button {\r\n  background-color: ghostwhite;\r\n  display: inline-block;\r\n  width: 60%;\r\n  padding: 0.2rem;\r\n  border: solid 1px black;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n.nlp-button-img {\r\n  width: 2.7rem;\r\n  float: left;\r\n}\r\n\r\n.nlp-buttons-management {\r\n  display: inline-flex;\r\n  visibility: hidden;\r\n  color: blue;\r\n  cursor: pointer;\r\n  gap: 10px;\r\n  margin-left: 1.8rem;\r\n}\r\n\r\n.nlp-button-line:hover .nlp-buttons-management {\r\n  visibility: visible;\r\n}\r\n\r\n.nlp-button-line:hover .nlp-button-img-change-pos {\r\n  visibility: visible;\r\n}\r\n\r\n.add-nlp-button {\r\n  width: 3.6rem;\r\n  margin-right: 3.6rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.edit-nlp-button-dialog-container span {\r\n  display: block;\r\n  margin-bottom: 1.8rem;\r\n}\r\n\r\n.add-button-dialog .modal-title {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.dialog-nlp-button-type {\r\n  display: block;\r\n}\r\n\r\n.nlp-button__name {\r\n  word-break: break-word;\r\n}\r\n\r\n.topic-pair-content-type__input {\r\n  font-size: 1.8rem;\r\n  display: inline-block;\r\n  width: 22rem;\r\n  height: 4rem;\r\n  margin-right: 2rem;\r\n  vertical-align: middle;\r\n}\r\n\r\n.input-wrapper {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.warning-icon {\r\n    color: red;\r\n    font-size: 20px;\r\n    margin-left: 8px;\r\n    cursor: pointer;\r\n}\r\n\r\n.topic-pairs-item-header input[type=\"text\"] {\r\n    padding-bottom: 5px;\r\n    height: auto;\r\n    margin-top: 16px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
